var checkParamExists = function(value, element, param, method) {
  if ( this.optional( element ) ) {
    return "dependency-mismatch";
  }

  method = typeof method === "string" && method || "check_param_redirect";
  var fieldTitle = param.title || 'E-mail';
  var field = param.field || 'email';

  if (field === 'ssn') {
    value = value.replace(/[^0-9]/g, "")
  }

  var previous = this.previousValue( element, method ),
    validator, data, optionDataString;

  if ( !this.settings.messages[ element.name ] ) {
    this.settings.messages[ element.name ] = {};
  }
  previous.originalMessage = previous.originalMessage || this.settings.messages[ element.name ][ method ];
  this.settings.messages[ element.name ][ method ] = previous.message;

  param = typeof param === "string" && { url: param } || param;
  optionDataString = $.param( $.extend( { data: value }, param.data ) );
  if ( previous.old === optionDataString ) {
    return previous.valid;
  }

  previous.old = optionDataString;
  validator = this;
  this.startRequest( element );
  data = {};
  data[field] = value;

  var valid = "pending";

  $.ajax( 
    $.extend( true, {
      mode: "abort",
      port: "validate" + element.name,
      dataType: "json",
      data: data,
      context: validator.currentForm,
      async: false,
      success: function( response ) {
        if (param.id && param.id.length) {
          var id = parseInt(param.id, 10);
          response = $.grep(response, function(model) {
            return model.id !== id;
          });
        }

        valid = response.length === 0;
        var errors, message, submitted;

        validator.settings.messages[ element.name ][ method ] = previous.originalMessage;
        if ( valid ) {
          submitted = validator.formSubmitted;
          validator.resetInternals();
          validator.toHide = validator.errorsFor( element );
          validator.formSubmitted = submitted;
          validator.successList.push( element );
          validator.invalid[ element.name ] = false;
          validator.showErrors();
        } else {
          errors = {};
          message = validator.defaultMessage( element, { method: method, parameters: [fieldTitle, response[0].id, response[0].name, response[0].account_slug ? response[0].account_slug : window.location.pathname.split('/')[1]] } );
          validator.settings.messages[ element.name ][ method ] = message;
          errors[ element.name ] = previous.message = message;
          validator.invalid[ element.name ] = true;
          validator.showErrors( errors );
        }
        previous.valid = valid;
        validator.stopRequest( element, valid );
      }
    }, param ) 
  );
  return valid;
}

$.validator.addMethod('check_param_redirect', checkParamExists);
$.validator.addMethod('check_param', function(value, element, param) {
  return checkParamExists.call(this, value, element, param, 'check_param');
});
$.validator.addMethod('check_param_redirect_user', function(value, element, param) {
  return checkParamExists.call(this, value, element, param, 'check_param_redirect_user');
});
$.validator.addMethod('check_param_redirect_account', function(value, element, param) {
  return checkParamExists.call(this, value, element, param, 'check_param_redirect_account');
});

$.validator.addMethod('check_param_redirect_account_view', function(value, element, param) {
  return checkParamExists.call(this, value, element, param, 'check_param_redirect_account_view');
});
